module.exports = __webpack_public_path__ + "img/online01.b3943416.png";